import React from "react";

const ScenarioContext = React.createContext();

export default ScenarioContext;
